module.exports = __webpack_public_path__ + "media/assets/img/video/italic-76513fd6b0fb93e125935f26dba976bc.svg";